import { createContext, ReactNode, useContext, useRef } from 'react';

export interface DraftEditorAdapter {
  read: () => {
    messageId: string;
    subject: string;
    body: string;
    documentIds?: string[];
    attachmentsPending?: boolean;
    revision: number;
    busy?: boolean;
  };
  flush: () => Promise<string>;
  lock: (locked: boolean) => void;
  apply: (
    message: {
      subject?: string | null;
      draftMessageBody: unknown;
      draftRevision: string;
      documents?: { id: string; filename?: string; byteSize?: number | null }[];
    },
    options?: { attachmentsOnly: boolean }
  ) => void;
}
interface EditorBridge {
  editors: Map<string, DraftEditorAdapter>;
  activeId: { current: string | null };
}
const Context = createContext<Map<string, EditorBridge> | null>(null);
export const useAssistantEditors = (eventId?: string) => {
  const registry = useContext(Context);
  if (!registry || !eventId) return null;
  let bridge = registry.get(eventId);
  if (!bridge) {
    bridge = { editors: new Map(), activeId: { current: null } };
    registry.set(eventId, bridge);
  }
  return bridge;
};

export function AssistantEditorProvider({ children }: { children: ReactNode }) {
  const registry = useRef(new Map<string, EditorBridge>());
  return (
    <Context.Provider value={registry.current}>{children}</Context.Provider>
  );
}
